import { useSelector } from 'react-redux';
import { selectById } from '../stores/launchDarkly';

const useDarkly = (id) => {
  const item = useSelector((state) => selectById(state, id));
  return item?.value;
};

export default useDarkly;
